import axios from 'axios';

export const postUploadedImage = async (params) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/front/medical-referral-file`,
    params,
  );
  return response.data;
};
